// core
import { Injectable } from '@angular/core';

@Injectable()
export class RaptorQuestionService {

  constructor() { }

  /**
   *
   * @param formData
   * @returns Array - of question data
   * @description Helper function that gets all the question declared in the form data
   */
  public getAllQuestions(formData: any) {
    let formQuestions: Array<any> = [];

    this.operateOnEachQuestion(formData, addQuestion, []);

    function addQuestion(question: any, operands?: Array<any>) {
      formQuestions.push(question);
    }

    return formQuestions;
  }

  /**
   *
   * @param formData
   * @param slug
   * @returns a form questions data
   * @description Helper function to get a question by its key from the form data
   */
  public getQuestionByKey(formData: any, slug: string) {
    let allQuestions = this.getAllQuestions(formData);
    let questionByKey = allQuestions.find((question: any) => {
      if (question.key === slug) {
        return question;
      }
      if (question.settings && question.settings.choices) {
        return question.settings.choices.find((choice: any) => choice.value === slug);
      }
      return false;
    });
    return questionByKey;
  }

  public getQuestionByAttribute(formData: any, attribute: string, value: any) {
    return this.getAllQuestions(formData).find((question: any) => {
      return question[attribute] === value;
    });
  }

  public getSectionByQuestionKey(formData: any, slug: string) {
    let sections: any[] = [];
    let questionSection: any;

    if (
      formData.sections &&
      formData.sections.length
    ) {
      sections = [...formData.sections];
    }

    if (
      formData.sidebar &&
      formData.sidebar.sections &&
      formData.sidebar.sections.length
    ) {
      sections = [...sections, formData.sidebar.sections];
    }

    sections.forEach((section: any) => {
      if (section.elements && section.elements.length) {
        let question = section.elements.find((element: any) => element.key === slug);
        if (question) {
          questionSection = section;
        }
      }
    });

    return questionSection;
  }

  public setQuestionAtribute(formData: any, key: string, attribute: string, value: any) {
    this.operateOnEachQuestion(formData, setAttribute, [attribute, value]);

    function setAttribute(question: any, operands: Array<any>) {
      if (question.key === key) {
        question[operands[0]] = operands[1];
      }
    }
  }

  public operateOnEachQuestion(formData: any, operation: Function, operands: any) {
    if (
      formData &&
      formData.sections &&
      formData.sections.length
    ) {
      formData.sections.forEach((section: any) => {
        if (section.elements && section.elements.length) {
          section.elements.forEach((question: any) => {
            operation(question, operands);
            if (question.type === 'repeater') {
              if (
                question.elements &&
                question.elements.length &&
                question.layout !== 'multiple'
              ) {
                question.elements.forEach((repeaterQuestion: any) => {
                  operation(repeaterQuestion, operands);
                });
              }
              if (
                question.fields &&
                question.fields.length &&
                question.layout === 'multiple'
              ) {
                question.fields.forEach((column: any) => {
                  column.forEach((fields: any) => {
                    fields.forEach((field: any) => {
                      operation(field, operands);
                    });
                  });
                });
              }
            }
          });
        }
      });
    }

    if (
      formData &&
      formData.sidebar &&
      formData.sidebar.sections &&
      formData.sidebar.sections.length
    ) {
      formData.sidebar.sections.forEach((section: any) => {
        if (section.elements && section.elements.length) {
          section.elements.forEach((question: any) => {
            operation(question, operands);
          });
        }
      });
    }
  }
}




